import CardContainer from "./CardContainer";

function Main() {
  return (
    <>
      <main className="main">
        <CardContainer />
      </main>
    </>
  );
}

export default Main;
